import React from 'react';

const Footer = () => {
    return (
        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                
                </div>
            </div>
        </footer>
    )
}

export default Footer;